module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// d:/documents/git/krkrsvchk/krkrsvchk_web/~/material-ui/~/babel-runtime/~/core-js/library/modules/_iter-step.js
// module id = 239
// module chunks = 1